import React from 'react'
import CommonPage from './CommonPage';

export default function ShareByPage() {
  return (
    <>
    <CommonPage name={'sharedBy'} />
    </>
  )
}
